import classNames from 'classnames';
import dynamic from 'next/dynamic';
import Image from 'next/image';
import { memo } from 'react';

import styles from './main.module.scss';

const Lottie = dynamic(() => import('lottie-react'), {
  ssr: false,
  loading: () => <div className="lottie-placeholder" />,
});

interface LottieSectionProps {
  isBgOrange?: boolean;
  reverse?: boolean;
  subject: string;
  // lottieData: any;
  imgUrl: string;
  title: React.ReactNode;
  text: React.ReactNode;
}

function LottieSection({
  isBgOrange,
  reverse,
  subject,
  // lottieData,
  imgUrl,
  title,
  text,
}: LottieSectionProps) {
  return (
    <section className={classNames({ [styles.bg_orange]: isBgOrange })}>
      <div className={classNames('inner', styles.inner)}>
        <div className={classNames(styles.content_wrap, { [styles.reverse]: reverse })}>
          <div className={styles.lottie_box}>
            <Image src={imgUrl} alt={subject} width="360" height="555" />
            {/* <Lottie animationData={lottieData} /> */}
          </div>
          <div className={styles.text_box}>
            <p className={styles.subject}>{subject}</p>
            <div className={styles.title}>{title}</div>
            <div className={styles.text}>{text}</div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default memo(LottieSection);
